import { cva } from "class-variance-authority"

export const tooltipContentVariants = cva(
  // prettier-ignore
  `
  tooltip-content
  relative
  z-50
  rounded-lg
  border
  border-(--border)
  bg-(--bg)
  px-3
  py-2
  text-general-primary-text
  shadow-bottom-100
  font-medium-400
  animate-in
  fade-in-50
  data-[side=bottom]:mt-[var(--arrow-height)]
  data-[side=left]:mr-[var(--arrow-height)]
  data-[side=right]:ml-[var(--arrow-height)]
  data-[side=top]:mb-[var(--arrow-height)]`,
  {
    variants: {
      variant: {
        // borders must be set as css vars for arrow to inherit
        info: [
          "[--border:var(--color-border-alert-information)]",
          "[--bg:var(--color-background-general-secondary-surface)]",
        ],
        warning: [
          "[--border:var(--color-border-alert-pending)]",
          "[--bg:var(--color-background-alert-order-working)]",
          "text-alerts-warning",
        ],
      },
      v2: { true: "", false: "" },
    },
    defaultVariants: {
      variant: "info",
      v2: false,
    },
    compoundVariants: [
      {
        v2: true,
        variant: "info",
        class: [
          "[--border:var(--color-border-general-neutral-02)]",
          "[--bg:var(--color-background-general-surface-03)]",
        ],
      },
    ],
  }
)
